






















import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class ColorComponent extends Vue {
  @Prop() value!: any;
  updateColor() {
    this.$emit('input', this.value);
  }
}
